export const SIMILR_PRODUCTS_ACTIONS = {
  SET_SIMILR_PRODUCTS: 'PRODUCT_DETAILS:SIMILR_PRODUCTS:SET_SIMILR_PRODUCTS',
  SET_SIMILR_PRODUCTS_IS_FAVORITE_DEVICE:
    'PRODUCT_DETAILS:SIMILR_PRODUCTS:SET_SIMILR_PRODUCTS_IS_FAVORITE_DEVICE',
  SET_SIMILR_PRODUCTS_IS_CMP_DEVICE:
    'PRODUCT_DETAILS:SIMILR_PRODUCTS:SET_SIMILR_PRODUCTS_IS_CMP_DEVICE',
  SET_SIMILR_PRODUCTS_IS_FEATCHING:
    'PRODUCT_DETAILS:SIMILR_PRODUCTS:SET_SIMILR_PRODUCTS_IS_FEATCHING',
  SET_CHOICE_RECOMMENDS_IS_CMP_DEVICE:
    'PRODUCT_DETAILS:SIMILR_PRODUCTS:SET_CHOICE_RECOMMENDS_IS_CMP_DEVICE',
};
